import { getCurrGeo } from "@/utils/getCurrGeo.ts";
import { positionAtom, updatingAtom } from "../app.ts";
import { getSearchParam } from "@/utils";
import loadDataByGeo from "./loadDataByGeo.ts";
import { _latitude, _longitude, pathnameAtom } from "../common.ts";
import { jotaiStore } from "@/atoms/store.ts";
const { get, set } = jotaiStore;

const HOME_LIKE_PATH_PREFIXES = ["/home", "/news", "/news/detail"].sort((a, b) => b.length - a.length);

function isHomeLikePath(pathname: string) {
  return HOME_LIKE_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

function persistPosition(latitude: any, longitude: any) {
  set(positionAtom, (prev: any) => ({
    ...prev,
    latitude,
    longitude,
  }));
  LocalStorage.setItem("LAT", latitude);
  LocalStorage.setItem("LONG", longitude);
}

function setUpdatingAtom(updating: boolean, showUpdating: boolean) {
  set(updatingAtom, (prev: any) => ({
    ...prev,
    updating,
    showUpdating,
  }));
}

async function withUpdating() {
  try {
    setUpdatingAtom(true, true);
    await loadDataByGeo();
    setUpdatingAtom(false, false);
  } catch (e) {
    setUpdatingAtom(false, false);
  }
}

function shouldPersistBrowserGeoAndReload(browserLat: any, browserLng: any): boolean {
  const latPrefixDiffers = _latitude && browserLat && String(_latitude).slice(0, 6) != String(browserLat).slice(0, 6);
  const lngPrefixDiffers = _longitude && browserLng && String(_longitude).slice(0, 6) != String(browserLng).slice(0, 6);
  const urlHasNoLatLng = !_latitude && !_longitude;
  return Boolean(latPrefixDiffers || lngPrefixDiffers || urlHasNoLatLng);
}

async function handleHomeData() {
  // url 有经纬度就不走浏览器经纬度
  if (_latitude && _longitude) {
    withUpdating();
    return;
  }
  getCurrGeo()
    .then(result => {
      const latitude = result.latitude;
      const longitude = result.longitude;
      persistPosition(latitude, longitude);
      loadDataByGeo();
    })
    .catch(() => {
      loadDataByGeo();
    });
}

function handleFallback() {
  // url 有经纬度就不走浏览器经纬度
  if (_latitude && _longitude) {
    withUpdating();
    return;
  }
  getCurrGeo()
    .then((result: any) => {
      if (isEmptyType(result)) {
        loadDataByGeo();
      } else {
        const latitude = result.latitude;
        const longitude = result.longitude;
        persistPosition(latitude, longitude);
        loadDataByGeo();
      }
    })
    .catch(() => {
      loadDataByGeo();
    });
}

const firstLoadDataByGeo = () => {
  getCurrGeo()
    .then((result: any) => {
      if (isEmptyType(result)) {
        loadDataByGeo();
        return;
      }
      const latitude = result.latitude;
      const longitude = result.longitude;
      if (latitude && longitude) {
        if (shouldPersistBrowserGeoAndReload(latitude, longitude)) {
          persistPosition(latitude, longitude);
          loadDataByGeo();
        }
      } else {
        loadDataByGeo();
      }
    })
    .catch(() => {
      loadDataByGeo();
    });
};

export async function refreshCurrGeo() {
  try {
    const apiAll = LocalStorage.getItem("API_ALL");
    const _latitude = getSearchParam("latitude");
    const _longitude = getSearchParam("longitude");
    // 第一次进来
    if (!apiAll) {
      // url 有经纬度就不走浏览器经纬度
      if (_latitude && _longitude) {
        withUpdating();
        return;
      }
      firstLoadDataByGeo();
    }
    // 第二次进来
    if (apiAll) {
      const pathname = get(pathnameAtom);
      if (isHomeLikePath(pathname)) {
        handleHomeData();
      } else {
        handleFallback();
      }
    }
  } catch (err: any) {
    console.error("Failed to get current location:", err.message);
  }
}
